// extracted by mini-css-extract-plugin
module.exports = {"todosSorter":"TodoSorter_todosSorter__2kZ7q","active":"TodoSorter_active__1t8FA"};